import React from "react"

const Pinterest = () => {
	return (
		<svg width="15.028" height="17.967" viewBox="0 0 15.028 17.967">
			<path
				id="Forma_1_copy_4"
				data-name="Forma 1 copy 4"
				d="M2.724,10.391c.934-1.536-.3-1.873-.494-2.985-.792-4.549,5.64-7.655,9.009-4.477,2.331,2.2.8,8.969-2.963,8.265-3.6-.671,1.763-6.058-1.109-7.115C4.834,3.218,3.593,6.707,4.7,8.44c-.649,2.982-2.048,5.789-1.481,9.526,1.835-1.238,2.455-3.61,2.963-6.084a5.42,5.42,0,0,0,2.591,1.148C13.109,13.343,15.533,9,14.939,5c-.526-3.552-4.33-5.36-8.39-4.935C3.339.395.141,2.808.007,6.26-.073,8.367.569,9.947,2.724,10.391Z"
				fill="#88c8bc"
			/>
		</svg>
	)
}

export default Pinterest
